import type { TO_TextData } from '@stratumn/studio-shared';

//? selectedVariable is set in the component on spawn using the selectedVariableRef from the block datInfo
export const initialTOTextData: Omit<TO_TextData, 'selectedVariable'> = {
  title: 'Default Text Title',
  viewType: 'Text',
  hasIcon: false,
  icon: 'Text'
};
